module.exports = __webpack_public_path__ + "static/media/gukhwa-jang.958bc695.jpg";